import { Injectable } from '@angular/core'
import { HttpService } from '../http.service'
import { ADMIN_API_ENDPOINTS } from '@api/common/api-endpoints'
import {
  TenantBookingDto,
  UpdateTenantBookingDto,
  CreateSlotsDto,
  UpdateSlotStatusDto
} from '../../dto/governance-admin/tenant-booking.dto'

@Injectable({
  providedIn: 'root'
})
export class TenantBookingApiService {
  constructor(private httpService: HttpService) {}

  async find(params: Record<string, string>): Promise<{ rows: TenantBookingDto[], count: number }> {
    return this.httpService.get(ADMIN_API_ENDPOINTS.OFFLINE_TENANTS, params)
  }

  async findOne(id: string): Promise<TenantBookingDto> {
    return this.httpService.get(`${ADMIN_API_ENDPOINTS.TENANT_BOOKING}/${id}`)
  }

  async update(id: string, data: UpdateTenantBookingDto): Promise<TenantBookingDto> {
    return this.httpService.put(`${ADMIN_API_ENDPOINTS.TENANT_BOOKING}/${id}`, data)
  }

  // Create new slots for a tenant booking
  async createSlots(tenantBookingId: string, data: CreateSlotsDto): Promise<void> {
    return this.httpService.post(`${ADMIN_API_ENDPOINTS.TENANT_BOOKING}/${tenantBookingId}/slots`, data)
  }

  // Update slot status (enable/disable)
  async updateSlotStatus(slotId: string, data: UpdateSlotStatusDto): Promise<void> {
    return this.httpService.patch(`${ADMIN_API_ENDPOINTS.TENANT_BOOKING}/slots/${slotId}`, data)
  }
}
